import { Instagram, Linkedin, Mail } from "lucide-react";

interface ProfileCardProps {
  avatar?: string;
  name: string;
  role: string;
  function: string;
  company: string;
  bio: string;
  socialLinks?: {
    instagram?: string;
    linkedin?: string;
    email?: string;
  };
}

export default function ProfileCard({
  avatar,
  name,
  role,
  function: userFunction,
  company,
  bio,
  socialLinks
}: ProfileCardProps) {
  return (
    <div className="bg-[#15203C] rounded-[10px] p-[30px] flex flex-col gap-[28px]">
      {/* Avatar + Name Section */}
      <div className="flex items-center gap-[20px]">
        <div className="size-[81.5px] rounded-full bg-gray-600 overflow-hidden flex-shrink-0">
          {avatar ? (
            <img
              src={avatar}
              alt={name}
              className="size-full object-cover"
            />
          ) : (
            <div className="size-full bg-gray-600" />
          )}
        </div>
        <div>
          <p className="text-[20px] font-semibold text-[#F6F6F6]">{name}</p>
          <p className="text-[14px] text-[#B0B0B0]">{role}</p>
        </div>
      </div>

      {/* Info Rows */}
      <div className="flex flex-col gap-[8px]">
        <div className="flex justify-between text-[12px] text-white">
          <p className="font-semibold w-[149px]">Função:</p>
          <p className="text-right">{userFunction}</p>
        </div>
        <div className="flex justify-between text-[12px] text-white">
          <p className="font-semibold w-[183px]">Empresa:</p>
          <p className="text-right">{company}</p>
        </div>
      </div>

      {/* Biography */}
      <div className="flex flex-col gap-[16px]">
        <p className="text-[14px] font-bold text-[#F6F6F6]">Biografia</p>
        <p className="text-[14px] text-[#B0B0B0] leading-relaxed">{bio}</p>
      </div>

      {/* Social Links */}
      <div className="flex flex-col gap-[16px]">
        <p className="text-[14px] font-bold text-[#F6F6F6]">Redes Sociais</p>
        <div className="flex gap-[20px]">
          {socialLinks?.instagram && (
            <a
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity"
            >
              <Instagram className="size-6 text-white" />
            </a>
          )}
          {socialLinks?.linkedin && (
            <a
              href={socialLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity"
            >
              <Linkedin className="size-6 text-white" />
            </a>
          )}
          {socialLinks?.email && (
            <a
              href={`mailto:${socialLinks.email}`}
              className="hover:opacity-70 transition-opacity"
            >
              <Mail className="size-6 text-white" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
